<template>
	<div :style="customStyle" class="goods_group_label_box" v-if="(returnLabelArray.length>0 || returnShow)">
		<template v-if="!!goods.attr && !!goods.attr.attr_country_code">
			<el-popover trigger="hover" :visible-arrow="false" placement="bottom-start" popper-class="goods-label-popover">
				<div class="content copy-content">
					<div @click="copy(goods.attr.attr_country_code)">
						<span>复制</span>
					</div>
					<span class="copy-content-text">{{goods.attr.attr_country_code}}</span>
				</div>
				<template slot="reference">
					<el-tag size="mini" type="error" :style="returnCountryStyle">国家码</el-tag>
				</template>
			</el-popover>
		</template>
		<template v-if="goods.is_jc==1">
			<el-tag size="mini" type="error" :style="returnJcStyle">集采</el-tag>
		</template>
		<template v-if="goods.traceability_code==1">
			<el-tag size="mini" type="error" :style="returnTraceabilityStyle">追溯码</el-tag>
		</template>
		<template v-for="(item,index) in returnLabelArray">
			<el-tag size="mini" type="error" :style="item.style">{{ item.text }}</el-tag>
		</template>
    </div>
</template>
<script>

export default {
	name: "goods-group-label",

	props: {
		goods: {
			type: Object,
			required: true,
			default: () => {}
		},
		customStyle: {
			type: String,
			default: ''
		}
	},
	data() {
		return {}
	},
	computed: {
		storeToken() {
			return this.$store.state.member.token;
		},
		returnLabelArray(){
			if(!this.goods) return [];
			let labelArray = [];
			let defaultStyle = 'border:none;display:flex;line-height: 22px;';
			if(this.goods.goods_label!=undefined&&this.goods.goods_label!=''&&this.goods.goods_label!=null&&this.goods.goods_label.length>0){
				labelArray = this.goods.goods_label.map(item=>{
					let newItem = {
						text:item.label_name,
						style:`background-color: ${item.label_color};color: ${item.font_color};${defaultStyle}`
					};
					return newItem;
				})
			}
			return labelArray;
		},
		returnCountryStyle(){
			const colors = this.goods.promotion_color;
			if(colors){
				return this.getTagStyle(colors.country_code_background_color,colors.country_code_font_color);
			}else{
				return this.getTagStyle('#6DD4C4','#FFFFFF');
			}
		},
		returnJcStyle(){
			const colors = this.goods.promotion_color;
			if(colors){
				return this.getTagStyle(colors.collect_background_color,colors.collect_font_color);
			}else{
				return this.getTagStyle('#FFAA00','#FFFFFF');
			}
		},
		returnTraceabilityStyle(){
			const colors = this.goods.promotion_color;
			if(colors){
				return this.getTagStyle(colors.trace_code_background_color,colors.trace_code_font_color);
			}else{
				return this.getTagStyle('#F55E82','#FFFFFF');
			}
		},
		returnShow(){
			let bool1 = (!!this.goods.attr && !!this.goods.attr.attr_country_code);
			let bool2 = (this.goods.is_jc==1);
			let bool3 = (this.goods.traceability_code==1);
			return bool1 || bool2 || bool3;
		}
	},
	methods: {
		copy(content){
            this.$util.copy(content);
            this.$message.success('复制成功');
        },
		getTagStyle(bgColor,fontColor){
			const defaultStyle = 'border:none;display:flex;line-height: 22px;';
			return `background-color: ${bgColor};color: ${fontColor};${defaultStyle}`
		}
	}
}
</script>

<style scoped lang="scss">
.goods_group_label_box{
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
}
.goods-label-popover {
    padding: 6px;
    margin-top: 6px !important;
    box-sizing: border-box;
    border: 1px solid #ff547b;
}
.content{
    display: flex;
    flex-direction: column;
    gap: 6px;
    >p:nth-child(1){
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
    >div:not(:first-child){
        display: flex;
        flex-direction: column;
        gap: 6px;
        >p:nth-child(1){
            font-size: 12px;
            line-height: 14px;
            color: #ff547b;
        }
        >p:nth-child(2){
            font-size: 12px;
            line-height: 14px;
            color: #787878;
        }
    }
    
}
.copy-content{
    align-items: center;
    flex-direction: row !important;
    >div:nth-child(1){
        padding: 2px;
        box-sizing: border-box;
        border: 1px solid #ff547b;
        border-radius: 4px;
        cursor: pointer;
        flex-shrink: 0;
        >span{
            font-size: 12px;
            line-height: 14px;
            color: #ff547b;
        }
    }
    >.copy-content-text{
        font-size: 12px;
        line-height: 14px;
        color: #333;
    }
}
</style>
